<template>
  <section class="purchases purchases--lk">
    <app-loading :is-loading="isLoading" />
    <template v-if="lotDetail.general">
      <div class="container">
        <div
          v-if="orderedDetails.length"
          class="row"
        >
          <div class="col-12">
            <div class="purchases__title-wrapper">
              <h2 class="purchases__title">
                {{ title }}
              </h2>
              <div
                v-for="section in orderedDetails"
                :key="section.id"
                class="row"
              >
                <div class="col-12">
                  <div class="purchases__form purchases__form--disabled">
                    <div class="purchases__form-title-wrapper">
                      <h3 class="purchases__form-title">
                        {{ section.title }}
                      </h3>
                      <!--                      <template v-if="hasRole('customer')">-->
                      <!--                        <button-->
                      <!--                          v-if="editableSections[section.id]"-->
                      <!--                          type="button"-->
                      <!--                          class="purchases__form-button purchases__form-button&#45;&#45;save"-->
                      <!--                          @click="setSectionEditedState(section.id, false)"-->
                      <!--                        />-->
                      <!--                        <button-->
                      <!--                          v-if="!editableSections[section.id]"-->
                      <!--                          type="submit"-->
                      <!--                          class="purchases__form-button purchases__form-button&#45;&#45;edit purchases__form-button&#45;&#45;active"-->
                      <!--                          @click="setSectionEditedState(section.id, true)"-->
                      <!--                        />-->
                      <!--                      </template>-->
                    </div>
                    <DetailsSectionCommon
                      v-for="item in section.items"
                      :key="section.id + item.name"
                      :data="item"
                      :editable="editableSections[item.name]?.enabled"
                      :saving="saving"
                      @edit-callback="editableSections[item.name]?.editCallback"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="docsTemplates.items.length > 0"
          class="row"
        >
          <div class="col-12">
            <div class="purchases__form purchases__form--disabled">
              <div class="purchases__form-title-wrapper">
                <h3 class="purchases__form-title">
                  {{ docsTemplates.title }}
                </h3>
              </div>
              <div class="purchases__form-block">
                <div class="row">
                  <div class="col-12">
                    <table class="purchases__table">
                      <thead class="purchases__thead">
                        <tr>
                          <th
                            v-for="column in docsTemplates.titles"
                            :key="column.name"
                          >
                            {{ column.title }}
                          </th>
                        </tr>
                      </thead>
                      <tbody class="purchases__tbody">
                        <DetailsSectionDocs
                          v-for="item in docsTemplates.items"
                          :key="item.name"
                          disabled
                          :data="item"
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="purchases__form purchases__form--disabled">
                <div class="container">
                  <div class="row">
                    <div class="col-12">
                      <div class="purchases__form-title-wrapper">
                        <h3 class="purchases__form-title">
                          {{ offer.title }}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="purchases__form-block">
              <div class="row">
                <div class="col-12">
                  <DeliverGoodsTable
                    :view-offers="supplierOffers"
                    :titles="offer.titles"
                    :items="offer.items"
                    :page-number="currentPage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        v-if="pageCount > 1"
        :pages="pageCount"
        :current-page="currentPage"
        @clickPage="clickPage"
      />
      <div class="container-fluid purchases__form-buttons purchases__form-buttons--mt row row--end">
        <div
          v-if="canSendOffer"
          class="col-12 col-md-4 col-xl-3"
        >
          <button
            class="purchases__button"
            role="link"
            @click="requestBtnClicked"
            @keypress.enter="requestBtnClicked"
          >
            Подать предложение
          </button>
        </div>
        <div class="col-12 col-md-4 col-xl-3">
          <router-link
            v-slot="{ navigate }"
            :to="{ name: 'ActualPurchases' }"
            custom
          >
            <button
              type="button"
              class="purchases__button purchases__button--white"
              role="link"
              @click="navigate"
              @keypress.enter="navigate"
            >
              Вернуться к закупкам
            </button>
          </router-link>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import DetailsSectionCommon from '@/components/details/DetailsSectionCommon.vue';
import DetailsSectionDocs from '@/components/details/DetailsSectionDocs.vue';
import DeliverGoodsTable from '@/components/details/DeliverGoodsTable.vue';
import Pagination from '@/components/elements/Pagination.vue';
import { dateFormat } from '@/utils/helpers';
import api from '@/api';
import FileDownload from 'js-file-download';
import th from 'air-datepicker/locale/th';

export default {
  name: 'Lot',
  components: {
    DetailsSectionCommon,
    DetailsSectionDocs,
    DeliverGoodsTable,
    Pagination,
  },
  data() {
    return {
      lotID: null,
      isLoading: true,
      editableSections: {},
      supplierOffers: null,
      currentPage: 1,
      saving: false,
    };
  },
  created() {
    this.lotID = this.$route.params.lotID;
  },
  async mounted() {
    await this.loadInfo();
    await this.loadLotDetail({ id: this.lotID });

    this.supplierOffers = {};
    (this.offer?.items || []).forEach((item) => {
      const offer = item.offer || {
        ...item,
        deliveryDateEnd: item.deliveryPeriodEnd,
        deliveryDateStart: item.deliveryPeriodStart,
        itemAnalogGuid: '',
        price: null,
      };
      this.supplierOffers[item.id] = {
        lotItemId: item.id,
        haveAnalog: offer.haveAnalog,
        itemAnalogGuid: offer.itemAnalogGuid,
        quantity: offer.quantity,
        unit: offer.unit,
        price: offer.price,
        sum: offer.price * offer.quantity,
        deliveryDate: offer.deliveryDate,
        deliveryDateEnd: dateFormat(offer.deliveryDateEnd),
        deliveryDateStart: dateFormat(offer.deliveryDateStart),
        guaranteeDate: offer.guaranteeDate,
        deliveryCondition: offer.deliveryCondition,
        guarantee: offer.guarantee,
        haveVAT: offer.haveVAT,
        fixCost: offer.fixCost || false,
      };
    });
    const lotContact = this.lotDetail.general.items.find((x) => x.name === 'contactEmail');

    this.editableSections = {
      contactPhone: {
        enabled: lotContact !== undefined
          && lotContact.value === this.user.userData.login,
        editCallback: (newValue) => this.saveContactPhone(newValue),
      },
    };
    this.isLoading = false;
  },
  computed: {
    ...mapState({
      lotDetail: (state) => state.lots.lotDetail,
      user: (state) => state.user,
      isLoggedIn: (state) => state.user.isLoggedIn,
    }),
    ...mapGetters({
      hasRole: 'user/hasRole',
    }),
    canSendOffer() {
      if (!this.isLoggedIn) {
        return true;
      }

      return this.isLoggedIn && !this.hasRole('customer');
    },
    pageCount() {
      return this.offer.items ? Math.ceil(this.offer.items.length / 10) : 0;
    },
    orderedDetails() {
      const order = ['general', 'organizer', 'delivery', 'recieveRequest', 'contractPrice'];
      const orderedList = [];
      order.forEach((sectionName) => {
        if (this.lotDetail[sectionName]) {
          const section = { ...this.lotDetail[sectionName] };
          section.id = sectionName;
          orderedList.push(section);
        }
      });
      return orderedList;
    },
    docsTemplates() {
      const templates = this.lotDetail.documentTemplates;
      if (!templates) {
        return {
          items: [],
        };
      }
      const columnsOrder = {
        title: 0,
        file: 1,
        dateTime: 2,
        link: 3,
      };
      const result = { ...templates };
      result.titles.sort((a, b) => columnsOrder[a.name] - columnsOrder[b.name]);
      return result;
    },
    offer() {
      return this.lotDetail.offerItems || {};
    },
    title() {
      const number = (
        this.lotDetail.general?.items?.find((item) => item.name === 'purchaseNumber') || {}
      ).value;
      return `Информация о закупке №${number}`;
    },
  },
  methods: {
    ...mapActions({
      loadInfo: 'user/loadInfo',
      loadLotDetail: 'lots/loadLotDetail',
    }),
    setSectionEditedState(sectionId, isTrue) {
      this.editableSections[sectionId] = isTrue;
    },
    clickPage(number) {
      this.currentPage = Number(number);
    },
    requestBtnClicked() {
      if (this.isLoggedIn) {
        this.$router.push({ name: 'Request', params: { lotID: this.lotID } });
      } else {
        this.$router.push({ name: 'Auth', query: { from: `/market/lot/${this.lotID}/request` } });
      }
    },
    async saveContactPhone(newPhone) {
      this.saving = true;
      try {
        await api.lots.contractor.updateContactPhone(this.lotID, newPhone);
      } catch (e) {
        console.error(e);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.row--end {
  justify-content: flex-end;
}
</style>
